<template>
  <fwb-sidebar class="bg-black text-white pt-1 py-0">
    <div
      :class="[
        'bg-black text-white p-0 m-0 h-screen fixed ml-[-12px] mt-[-20px] mr-[-12px] px-0 transition-all duration-300',
        isCollapsed ? 'w-[60px]' : 'w-[240px]'
      ]"
    >
      <!-- Sidebar Header -->
      <div class="flex items-center justify-between" :class="isCollapsed ? 'p-0 justify-center' : 'p-5'">
        
        <!-- Collapse Button-->
        <button
          v-if="!isCollapsed"
          @click="$emit('toggle-collapse')"
          class="absolute right-2 rounded-lg transition-all duration-200 hover:bg-darkgray2 p-1"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 20.25H16.25C17.3109 20.25 18.3283 19.8286 19.0784 19.0784C19.8286 18.3283 20.25 17.3109 20.25 16.25V13.75M12 20.25H7.75C6.68913 20.25 5.67172 19.8286 4.92157 19.0784C4.17143 18.3283 3.75 17.3109 3.75 16.25V12M12 20.25V15C12 14.2044 11.6839 13.4413 11.1213 12.8787C10.5587 12.3161 9.79565 12 9 12H3.75M3.75 12V7.75C3.75 6.68913 4.17143 5.67172 4.92157 4.92157C5.67172 4.17143 6.68913 3.75 7.75 3.75H10.25M20.25 10.25H14.75C14.4848 10.2499 14.2305 10.1445 14.043 9.957M14.043 9.957C13.862 9.776 13.75 9.526 13.75 9.25V3.75M14.043 9.957L14.75 9.25L20.25 3.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <!-- Collapsed Menu Items with Tooltips -->
      <div v-if="isCollapsed">
        <!-- Expand Button -->
        <fwb-tooltip placement="right" theme="bg-darkgray">
          <template #trigger>
            <div
              @click="$emit('toggle-collapse')"
              class="flex items-center justify-center m-2 p-2 text-base font-normal text-white transition-all duration-200 rounded-lg group hover:bg-darkgray cursor-pointer hover:scale-110"        
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M13.0103 1.97852H18.0103M18.0103 1.97852V6.97852M18.0103 1.97852L13.0103 6.97852M1.98926 6.97852V1.97852H7.01026M7.01026 18.0205H1.98926V12.9785M18.0103 12.9785V18.0205H13.0103M13.0103 12.9785L18.0103 17.9785M2.01026 1.97852L7.01026 6.97852M7.01026 12.9785L2.01026 17.9785" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>         
            </div>
          </template>
          <template #content>Abrir menú</template>
        </fwb-tooltip>

        <!-- Dashboard -->
         <fwb-tooltip placement="right" theme="bg-darkgray">
          <template #trigger>
            <fwb-sidebar-item
              to="/dashboard"
              class="m-2 p-2 text-base font-normal text-white transition-all duration-200 rounded-lg group hover:!bg-darkgray2 hover:scale-105"        
              :class="{ 'bg-darkgray': current_path == 'dashboard' }"
              @click="change_path('dashboard')"
            >
              <template #icon>
                <svg class="text-white transition-transform duration-200 group-hover:rotate-12" width="20" height="20" viewBox="0 0 20 20" fill="#737373">
                  <path d="M15.43 9.09H9.09V2.75c0-.54-.41-1-.95-.91C3.94 2.3 1 6.04 1 10.5 1 15.19 4.81 19 9.5 19c4.46 0 8.2-2.94 8.66-7.14.09-.54-.37-.95-.91-.95-.01 0-.01 0 0 0Z"/>
                  <path d="M11.36 0c-.14 0-.28.01-.51.02-.45.08-.76.48-.76.93v8.14h8.16c.45 0 .85-.31.93-.76.01-.17.02-.34.02-.51C19.2 3.86 16.32.98 12.36.98-.64-.02 11.5 0 11.36 0Z"/>
                </svg>
              </template>
            </fwb-sidebar-item>
          </template>
          <template #content>Dashboard</template>
        </fwb-tooltip>

        <!-- Usuarios con Dropdown Flotante -->
        <div class="relative" @mouseenter="showFloatingMenu('usuarios')" @mouseleave="hideFloatingMenu('usuarios')">
          <fwb-tooltip placement="right" theme="bg-darkgray">
            <template #trigger>
              <fwb-sidebar-item
                class="m-2 p-2 text-base font-normal text-white transition-all duration-200 rounded-lg group hover:!bg-darkgray2 hover:scale-105 cursor-pointer"        
                :class="{ 'bg-darkgray': current_path == 'users' }"
              >
                <template #icon>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" class="transition-transform duration-200 group-hover:scale-110">
                    <g clip-path="url(#clip0_3710_3826)">
                      <path d="M16.8341 15.4625C15.9466 14.0325 13.9928 12.5 9.99909 12.5C6.00534 12.5 4.05284 14.0312 3.16409 15.4625C3.98295 16.489 5.02274 17.3177 6.20611 17.8869C7.38948 18.4561 8.68596 18.7511 9.99909 18.75C11.3122 18.7511 12.6087 18.4561 13.7921 17.8869C14.9754 17.3177 16.0152 16.489 16.8341 15.4625Z" fill="#737373"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 11.25C10.9946 11.25 11.9484 10.8549 12.6517 10.1517C13.3549 9.44839 13.75 8.49456 13.75 7.5C13.75 6.50544 13.3549 5.55161 12.6517 4.84835C11.9484 4.14509 10.9946 3.75 10 3.75C9.00544 3.75 8.05161 4.14509 7.34835 4.84835C6.64509 5.55161 6.25 6.50544 6.25 7.5C6.25 8.49456 6.64509 9.44839 7.34835 10.1517C8.05161 10.8549 9.00544 11.25 10 11.25Z" fill="#737373"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 1.25C7.67936 1.25 5.45376 2.17187 3.81282 3.81282C2.17187 5.45376 1.25 7.67936 1.25 10C1.25 12.3206 2.17187 14.5462 3.81282 16.1872C5.45376 17.8281 7.67936 18.75 10 18.75C12.3206 18.75 14.5462 17.8281 16.1872 16.1872C17.8281 14.5462 18.75 12.3206 18.75 10C18.75 7.67936 17.8281 5.45376 16.1872 3.81282C14.5462 2.17187 12.3206 1.25 10 1.25ZM0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10Z" fill="#737373"/>
                    </g>
                  </svg>
                </template>
              </fwb-sidebar-item>
            </template>
            <template #content>Usuarios</template>
          </fwb-tooltip>
          
          <!-- Menú Flotante -->
          <transition name="slide-fade">
            <div 
              v-if="floatingMenus.usuarios"
              class="absolute left-full top-0 ml-2 bg-darkgray rounded-lg shadow-2xl py-2 min-w-[180px] z-50 border border-neutral-700"
            >
              <div class="px-4 py-2 text-xs text-neutral-400 font-semibold uppercase">Usuarios</div>
              <button
                @click="navigateTo('/users', 'users')"
                class="w-full text-left px-4 py-2 text-sm text-white hover:bg-darkgray2 transition-colors duration-150 flex items-center gap-2"
              >
                <span class="w-1.5 h-1.5 rounded-full bg-pink-500" v-if="current_path == 'users'"></span>
                Equipo Interno
              </button>
            </div>
          </transition>
        </div>

        <!-- Asesores -->
        <fwb-tooltip placement="right" theme="bg-darkgray">
          <template #trigger>
            <fwb-sidebar-item
              to="/advisors"
              class="m-2 p-2 text-base font-normal text-white transition-all duration-200 rounded-lg group hover:!bg-darkgray2 hover:scale-105"        
              :class="{ 'bg-darkgray': current_path == 'asesor' }"
              @click="change_path('asesor')"
            >
              <template #icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none" class="transition-transform duration-200 group-hover:scale-110">
                  <g clip-path="url(#clip0_3772_287)">
                    <path d="M9.45587 0.479159C9.08871 0.169715 8.62399 0 8.14381 0C7.66364 0 7.19892 0.169715 6.83175 0.479159L0.723894 5.62967C0.497188 5.82073 0.314948 6.05901 0.189911 6.32784C0.0648754 6.59667 6.12856e-05 6.88956 0 7.18604V15.6104C0 16.4845 0.709417 17.1939 1.58352 17.1939H4.75056C5.17053 17.1939 5.57331 17.027 5.87028 16.7301C6.16724 16.4331 6.33408 16.0303 6.33408 15.6104V11.0797C6.33408 11.0197 6.35791 10.9622 6.40033 10.9197C6.44276 10.8773 6.5003 10.8535 6.56029 10.8535H9.72733C9.78733 10.8535 9.84487 10.8773 9.88729 10.9197C9.92972 10.9622 9.95355 11.0197 9.95355 11.0797V14.1499C10.3388 13.8288 10.8117 13.6311 11.3109 13.5826V12.9401C11.0148 12.4474 10.8584 11.8834 10.8584 11.3086C10.8584 10.9231 10.9272 10.5549 11.053 10.2137C10.909 9.99338 10.7125 9.81238 10.481 9.6871C10.2496 9.56181 9.99052 9.49619 9.72733 9.49617H6.56029C6.14032 9.49617 5.73754 9.663 5.44058 9.95997C5.14361 10.2569 4.97677 10.6597 4.97677 11.0797V15.6104C4.97677 15.6704 4.95294 15.7279 4.91052 15.7703C4.86809 15.8127 4.81055 15.8366 4.75056 15.8366H1.58352C1.52352 15.8366 1.46598 15.8127 1.42356 15.7703C1.38114 15.7279 1.3573 15.6704 1.3573 15.6104V7.18604C1.3574 7.08724 1.37908 6.98965 1.42081 6.9001C1.46254 6.81054 1.52332 6.73118 1.5989 6.66755L7.70676 1.51704C7.82911 1.41405 7.98389 1.35758 8.14381 1.35758C8.30374 1.35758 8.45852 1.41405 8.58086 1.51704L14.6887 6.66755C14.7643 6.73118 14.8251 6.81054 14.8668 6.9001C14.9086 6.98965 14.9302 7.08724 14.9303 7.18604V8.27188C15.4515 8.42752 15.9166 8.71346 16.2876 9.09169V7.18695C16.2876 6.89046 16.2228 6.59757 16.0977 6.32874C15.9727 6.05991 15.7904 5.82164 15.5637 5.63057L9.45587 0.479159ZM16.2876 11.3086C16.2876 11.9086 16.0493 12.484 15.6251 12.9082C15.2008 13.3325 14.6254 13.5708 14.0255 13.5708C13.4255 13.5708 12.8501 13.3325 12.4259 12.9082C12.0016 12.484 11.7633 11.9086 11.7633 11.3086C11.7633 10.7087 12.0016 10.1333 12.4259 9.70902C12.8501 9.28478 13.4255 9.04645 14.0255 9.04645C14.6254 9.04645 15.2008 9.28478 15.6251 9.70902C16.0493 10.1333 16.2876 10.7087 16.2876 11.3086ZM18.0974 16.1723C18.0974 17.5803 16.9337 19 14.0255 19C11.1172 19 9.95355 17.5857 9.95355 16.1723V16.0791C9.95355 15.1923 10.672 14.4757 11.5579 14.4757H16.493C17.3798 14.4757 18.0974 15.1932 18.0974 16.0791V16.1723Z" fill="#737373"/>
                  </g>
                </svg>
              </template>
            </fwb-sidebar-item>
          </template>
          <template #content>Asesores</template>
        </fwb-tooltip>

        <!-- Catálogos con Dropdown Flotante -->
        <div class="relative" @mouseenter="showFloatingMenu('catalogos')" @mouseleave="hideFloatingMenu('catalogos')">
          <fwb-tooltip placement="right" theme="bg-darkgray">
            <template #trigger>
              <fwb-sidebar-item
                class="m-2 p-2 text-base font-normal text-white transition-all duration-200 rounded-lg group hover:!bg-darkgray2 hover:scale-105 cursor-pointer"        
              >
                <template #icon>
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24" fill="none" class="transition-transform duration-200 group-hover:scale-110">
                    <path fill="none" stroke="#737373" stroke-width="2" d="M5 6L1 4.5v13.943L12 23l11-4.557V4l-4 2M5 16V2l7 3l7-3v14l-7 3zm6.95-11v14"/>
                  </svg>
                </template>
              </fwb-sidebar-item>
            </template>
            <template #content>Catálogos</template>
          </fwb-tooltip>
          
          <!-- Menú Flotante -->
          <transition name="slide-fade">
            <div 
              v-if="floatingMenus.catalogos"
              class="absolute left-full top-0 ml-2 bg-darkgray rounded-lg shadow-2xl py-2 min-w-[200px] z-50 border border-neutral-700"
            >
              <div class="px-4 py-2 text-xs text-neutral-400 font-semibold uppercase">Catálogos</div>
              <button
                v-for="(item, index) in [
                  { path: 'rolesList', route: '/catalogs/roles', label: 'Roles' },
                  { path: 'cargosList', route: '/catalogs/charges', label: 'Cargos' },
                  { path: 'accountList', route: '/catalogs/accounts', label: 'Cuentas' },
                  { path: 'planList', route: '/catalogs/plans', label: 'Planes' },
                  { path: 'countriesList', route: '/catalogs/countries', label: 'Códigos telefónicos' }
                ]"
                :key="index"
                @click="navigateTo(item.route, item.path)"
                class="w-full text-left px-4 py-2 text-sm text-white hover:bg-darkgray2 transition-colors duration-150 flex items-center gap-2"
              >
                <span class="w-1.5 h-1.5 rounded-full bg-pink-500" v-if="current_path == item.path"></span>
                {{ item.label }}
              </button>
            </div>
          </transition>
        </div>

        <!-- Propiedades -->
        <fwb-tooltip placement="right" theme="bg-darkgray">
          <template #trigger>
            <fwb-sidebar-item
              to="/properties"
              class="m-2 p-2 text-base font-normal text-white transition-all duration-200 rounded-lg group hover:!bg-darkgray2 hover:scale-105"        
              :class="{ 'bg-darkgray': current_path == 'properties' }"
              @click="change_path('properties')"
            >
             <template #icon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="text-white text-xs transition-transform duration-200 group-hover:scale-110"
                  width="25"
                  height="25"
                  viewBox="0 0 2160 2160"
                >
                  <path
                    fill="#737373"
                    d="M1280 1920h384v128h-512v-896H768v896H256V987l-83 82l-90-90l877-877l877 877l-90 90l-83-82v165h-128V859L960 282L384 859v1061h256v-896h640zm768-640v768h-128v-256h-512v-512zm-128 128h-384v256h384z"
                  />
                </svg>
              </template>
            </fwb-sidebar-item>
          </template>
          <template #content>Propiedades</template>
        </fwb-tooltip>

        <!-- Prospectos -->
        <fwb-tooltip placement="right" theme="bg-darkgray">
          <template #trigger>
            <fwb-sidebar-item
              to="/prospect/prospect-list"
              class="m-2 p-2 text-base font-normal text-white transition-all duration-200 rounded-lg group hover:!bg-darkgray2 hover:scale-105"        
              :class="{ 'bg-darkgray': current_path == 'prospect' }"
              @click="change_path('prospect')"
            >
             <template #icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M19.6875 18.375C19.6875 18.375 21 18.375 21 17.0625C21 15.75 19.6875 11.8125 14.4375 11.8125C9.1875 11.8125 7.875 15.75 7.875 17.0625C7.875 18.375 9.1875 18.375 9.1875 18.375H19.6875ZM9.21637 17.0625H19.6586C19.6648 
                  17.0618 19.6709 17.0609 19.677 17.0599L19.6875 17.0573C19.6849 16.7108 19.4683 15.7054 18.69 14.7998C17.9655 13.9506 16.6924 13.125 14.4375 13.125C12.1839 13.125 10.9108 13.9519 10.185 14.7998C9.40669 15.7054 9.18881 16.7121 9.1875 17.0573C9.19711 17.0591 9.20673 
                  17.0609 9.21637 17.0625ZM14.4375 9.1875C15.1337 9.1875 15.8014 8.91094 16.2937 8.41866C16.7859 7.92637 17.0625 7.25869 17.0625 6.5625C17.0625 5.86631 16.7859 5.19863 16.2937 4.70634C15.8014 4.21406 15.1337 3.9375 14.4375 3.9375C13.7413 3.9375 13.0736 4.21406 12.5813 
                  4.70634C12.0891 5.19863 11.8125 5.86631 11.8125 6.5625C11.8125 7.25869 12.0891 7.92637 12.5813 8.41866C13.0736 8.91094 13.7413 9.1875 14.4375 9.1875ZM18.375 6.5625C18.375 7.07958 18.2732 7.5916 18.0753 8.06932C17.8774 8.54704 17.5874 8.9811 17.2217 9.34673C16.8561 9.71236 
                  16.422 10.0024 15.9443 10.2003C15.4666 10.3982 14.9546 10.5 14.4375 10.5C13.9204 10.5 13.4084 10.3982 12.9307 10.2003C12.453 10.0024 12.0189 9.71236 11.6533 9.34673C11.2876 8.9811 10.9976 8.54704 10.7997 8.06932C10.6018 7.5916 10.5 7.07958 10.5 6.5625C10.5 5.51821 10.9148 4.51669 11.6533 3.77827C12.3917 
                  3.03984 13.3932 2.625 14.4375 2.625C15.4818 2.625 16.4833 3.03984 17.2217 3.77827C17.9602 4.51669 18.375 5.51821 18.375 6.5625ZM9.1035 12.18C8.57848 12.0147 8.03727 11.906 7.48912 11.8558C7.18112 11.8265 6.87189 11.8121 6.5625 11.8125C1.3125 11.8125 0 15.75 0 17.0625C0 17.9379 0.437063 18.375 1.3125 
                  18.375H6.846C6.65143 17.9653 6.55439 17.516 6.5625 17.0625C6.5625 15.7369 7.05731 14.3824 7.99312 13.251C8.31206 12.8651 8.6835 12.5042 9.1035 12.18ZM6.4575 13.125C4.26825 13.1512 3.02531 13.965 2.31 14.7998C1.52644 15.7106 1.3125 16.7199 1.3125 17.0625H5.25C5.25 15.6909 5.67394 14.3246 6.4575 13.125ZM1.96875 
                  7.21875C1.96875 6.17446 2.38359 5.17294 3.12202 4.43452C3.86044 3.69609 4.86196 3.28125 5.90625 3.28125C6.95054 3.28125 7.95206 3.69609 8.69048 4.43452C9.42891 5.17294 9.84375 6.17446 9.84375 7.21875C9.84375 8.26304 9.42891 9.26456 8.69048 10.003C7.95206 10.7414 6.95054 11.1562 5.90625 11.1562C4.86196 11.1562 
                  3.86044 10.7414 3.12202 10.003C2.38359 9.26456 1.96875 8.26304 1.96875 7.21875ZM5.90625 4.59375C5.21006 4.59375 4.54238 4.87031 4.05009 5.36259C3.55781 5.85488 3.28125 6.52256 3.28125 7.21875C3.28125 7.91494 3.55781 8.58262 4.05009 9.07491C4.54238 9.56719 5.21006 9.84375 5.90625 9.84375C6.60244 9.84375 7.27012 
                  9.56719 7.76241 9.07491C8.25469 8.58262 8.53125 7.91494 8.53125 7.21875C8.53125 6.52256 8.25469 5.85488 7.76241 5.36259C7.27012 4.87031 6.60244 4.59375 5.90625 4.59375Z" fill="#737373"/>
                </svg>
              </template>
            </fwb-sidebar-item>
          </template>
          <template #content>Prospectos</template>
        </fwb-tooltip>

        <!-- Compañia -->
        <fwb-tooltip placement="right" theme="bg-darkgray">
          <template #trigger>
            <fwb-sidebar-item
              to="/company/company-list"
              class="m-2 p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:!bg-darkgray2"        
              :class="{ 'bg-darkgray': current_path == 'company' }"
              @click="change_path('company')"
            >
              <template #icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 15.625C0 16.1223 0.197544 16.5992 0.549175 16.9508C0.900805 17.3025 1.37772 17.5 1.875 17.5H18.125C18.6223 17.5 19.0992 17.3025 19.4508 16.9508C19.8025 16.5992 20 16.1223 20 15.625V8.125H18.75V15.625C18.75 15.7908 18.6842 15.9497 18.5669 16.0669C18.4497 16.1842 18.2908 16.25 18.125 16.25H1.875C1.70924 16.25 1.55027 16.1842 1.43306 16.0669C1.31585 15.9497 1.25 15.7908 1.25 15.625V8.125H0V15.625Z" fill="#737373"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 5.625C0 5.12772 0.197544 4.65081 0.549175 4.29917C0.900805 3.94754 1.37772 3.75 1.875 3.75H18.125C18.6223 3.75 19.0992 3.94754 19.4508 4.29917C19.8025 4.65081 20 5.12772 20 5.625V8.605L10.4825 11.1425C10.1663 11.2267 9.83366 11.2267 9.5175 11.1425L0 8.605V5.625ZM1.875 5C1.70924 5 1.55027 5.06585 1.43306 5.18306C1.31585 5.30027 1.25 5.45924 1.25 5.625V7.645L9.83875 9.935C9.9444 9.96321 10.0556 9.96321 10.1612 9.935L18.75 7.645V5.625C18.75 5.45924 18.6842 5.30027 18.5669 5.18306C18.4497 5.06585 18.2908 5 18.125 5H1.875ZM6.25 3.125C6.25 2.62772 6.44754 2.15081 6.79917 1.79917C7.15081 1.44754 7.62772 1.25 8.125 1.25H11.875C12.3723 1.25 12.8492 1.44754 13.2008 1.79917C13.5525 2.15081 13.75 2.62772 13.75 3.125V3.75H12.5V3.125C12.5 2.95924 12.4342 2.80027 12.3169 2.68306C12.1997 2.56585 12.0408 2.5 11.875 2.5H8.125C7.95924 2.5 7.80027 2.56585 7.68306 2.68306C7.56585 2.80027 7.5 2.95924 7.5 3.125V3.75H6.25V3.125Z" fill="#737373"/>
                </svg>
              </template>
            </fwb-sidebar-item>
          </template>
          <template #content>Compañías</template>
        </fwb-tooltip>

        <!-- Blog -->
        <div class="relative" @mouseenter="showFloatingMenu('blog')" @mouseleave="hideFloatingMenu('blog')">
          <fwb-tooltip placement="right" theme="bg-darkgray">
            <template #trigger>
              <fwb-sidebar-item
                class="m-2 p-2 text-base font-normal text-white transition-all duration-200 rounded-lg group hover:!bg-darkgray2 hover:scale-105 cursor-pointer"        
              >
                <template #icon>
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24" fill="none" class="transition-transform duration-200 group-hover:scale-110">
                    <path fill="none" stroke="#737373" stroke-width="2" d="M5 6L1 4.5v13.943L12 23l11-4.557V4l-4 2M5 16V2l7 3l7-3v14l-7 3zm6.95-11v14"/>
                  </svg>
                </template>
              </fwb-sidebar-item>
            </template>
            <template #content>Blog</template>
          </fwb-tooltip>
          
          <!-- Menú Flotante -->
          <transition name="slide-fade">
            <div 
              v-if="floatingMenus.blog"
              class="absolute left-full top-0 ml-2 bg-darkgray rounded-lg shadow-2xl py-2 min-w-[200px] z-50 border border-neutral-700"
            >
              <div class="px-4 py-2 text-xs text-neutral-400 font-semibold uppercase">Blog</div>
              <button
                v-for="(item, index) in [
                  { path: 'post_lis', route: '/blog/post', label: 'Post' },
                  { path: 'categorias_list', route: '/blog/categories', label: 'Categorías' }
                ]"
                :key="index"
                @click="navigateTo(item.route, item.path)"
                class="w-full text-left px-4 py-2 text-sm text-white hover:bg-darkgray2 transition-colors duration-150 flex items-center gap-2"
              >
                <span class="w-1.5 h-1.5 rounded-full bg-pink-500" v-if="current_path == item.path"></span>
                {{ item.label }}
              </button>
            </div>
          </transition>
        </div>

        <!-- Legal -->
        <fwb-tooltip placement="right" theme="bg-darkgray">
          <template #trigger>
            <fwb-sidebar-item
              to="/legal"
              class="m-2 p-2 text-base font-normal text-white transition-all duration-200 rounded-lg group hover:!bg-darkgray2 hover:scale-105"        
              :class="{ 'bg-darkgray': current_path == 'legal' }"
              @click="change_path('legal')"
            >
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 15.625C0 16.1223 0.197544 16.5992 0.549175 16.9508C0.900805 17.3025 1.37772 17.5 1.875 17.5H18.125C18.6223 17.5 19.0992 17.3025 19.4508 16.9508C19.8025 16.5992 20 16.1223 20 15.625V8.125H18.75V15.625C18.75 15.7908 18.6842 15.9497 18.5669 16.0669C18.4497 16.1842 18.2908 16.25 18.125 16.25H1.875C1.70924 16.25 1.55027 16.1842 1.43306 16.0669C1.31585 15.9497 1.25 15.7908 1.25 15.625V8.125H0V15.625Z" fill="#737373"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 5.625C0 5.12772 0.197544 4.65081 0.549175 4.29917C0.900805 3.94754 1.37772 3.75 1.875 3.75H18.125C18.6223 3.75 19.0992 3.94754 19.4508 4.29917C19.8025 4.65081 20 5.12772 20 5.625V8.605L10.4825 11.1425C10.1663 11.2267 9.83366 11.2267 9.5175 11.1425L0 8.605V5.625ZM1.875 5C1.70924 5 1.55027 5.06585 1.43306 5.18306C1.31585 5.30027 1.25 5.45924 1.25 5.625V7.645L9.83875 9.935C9.9444 9.96321 10.0556 9.96321 10.1612 9.935L18.75 7.645V5.625C18.75 5.45924 18.6842 5.30027 18.5669 5.18306C18.4497 5.06585 18.2908 5 18.125 5H1.875ZM6.25 3.125C6.25 2.62772 6.44754 2.15081 6.79917 1.79917C7.15081 1.44754 7.62772 1.25 8.125 1.25H11.875C12.3723 1.25 12.8492 1.44754 13.2008 1.79917C13.5525 2.15081 13.75 2.62772 13.75 3.125V3.75H12.5V3.125C12.5 2.95924 12.4342 2.80027 12.3169 2.68306C12.1997 2.56585 12.0408 2.5 11.875 2.5H8.125C7.95924 2.5 7.80027 2.56585 7.68306 2.68306C7.56585 2.80027 7.5 2.95924 7.5 3.125V3.75H6.25V3.125Z" fill="#737373"/>
              </svg>
            </template>
            </fwb-sidebar-item>
          </template>
          <template #content>Legal</template>
        </fwb-tooltip>

        <!-- Reportes -->
        <div class="relative" @mouseenter="showFloatingMenu('reportes')" @mouseleave="hideFloatingMenu('reportes')">
          <fwb-tooltip placement="right" theme="bg-darkgray">
            <template #trigger>
              <fwb-sidebar-item
                class="m-2 p-2 text-base font-normal text-white transition-all duration-200 rounded-lg group hover:!bg-darkgray2 hover:scale-105 cursor-pointer"        
              >
                <template #icon>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M9 17V15H13V17H9ZM9 13V11H17V13H9ZM9 9V7H17V9H9ZM5 21C4.45 21 3.979 20.804 3.587 20.412C3.195 20.02 2.99934 19.5493 3 19V5C3 4.45 3.196 3.979 3.588 3.587C3.98 3.195 4.45067 2.99934 5 3H19C19.55 3 20.021 3.196 20.413 3.588C20.805 3.98 21.0007 4.45067 21 5V19C21 19.55 20.804 20.021 20.412 20.413C20.02 20.805 19.5493 21.0007 19 21H5ZM5 19H19V5H5V19Z" fill="#737373"/>
                  </svg>
                </template>
              </fwb-sidebar-item>
            </template>
            <template #content>Reportes</template>
          </fwb-tooltip>
          
          <!-- Menú Flotante -->
          <transition name="slide-fade">
            <div 
              v-if="floatingMenus.reportes"
              class="absolute left-full top-0 ml-2 bg-darkgray rounded-lg shadow-2xl py-2 min-w-[200px] z-50 border border-neutral-700"
            >
              <div class="px-4 py-2 text-xs text-neutral-400 font-semibold uppercase">Reportes</div>
              <button
                v-for="(item, index) in [
                  { path: 'reports_list', route: '/reports/list', label: 'Lista' },
                  { path: 'reports_reasons_list', route: '/reports/reasons', label: 'Motivos' }
                ]"
                :key="index"
                @click="navigateTo(item.route, item.path)"
                class="w-full text-left px-4 py-2 text-sm text-white hover:bg-darkgray2 transition-colors duration-150 flex items-center gap-2"
              >
                <span class="w-1.5 h-1.5 rounded-full bg-pink-500" v-if="current_path == item.path"></span>
                {{ item.label }}
              </button>
            </div>
          </transition>
        </div>

        <!-- Logs Servidor -->
         <fwb-tooltip placement="right" theme="bg-darkgray">
          <template #trigger>
            <fwb-sidebar-item
              class="m-2 p-2 text-base font-normal text-white transition-all duration-200 rounded-lg group hover:!bg-darkgray2 hover:scale-105"        
              :class="{ 'bg-darkgray': current_path == 'legal' }"
              @click="redirectToTelescope"
            >
              <template #icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#555050" d="M12 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-2 12c-.25 0-.46-.18-.5-.42l-.37-2.65c-.63-.25-1.17-.59-1.69-.99l-2.49 1.01c-.22.08-.49 0-.61-.22l-2-3.46a.493.493 0 0 1 .12-.64l2.11-1.66L4.5 12l.07-1l-2.11-1.63a.493.493 0 0 1-.12-.64l2-3.46c.12-.22.39-.31.61-.22l2.49 1c.52-.39 1.06-.73 1.69-.98l.37-2.65c.04-.24.25-.42.5-.42h4c.25 0 .46.18.5.42l.37 2.65c.63.25 1.17.59 1.69.98l2.49-1c.22-.09.49 0 .61.22l2 3.46c.13.22.07.49-.12.64L19.43 11l.07 1l-.07 1l2.11 1.63c.19.15.25.42.12.64l-2 3.46c-.12.22-.39.31-.61.22l-2.49-1c-.52.39-1.06.73-1.69.98l-.37 2.65c-.04.24-.25.42-.5.42zm1.25-18l-.37 2.61c-1.2.25-2.26.89-3.03 1.78L5.44 7.35l-.75 1.3L6.8 10.2a5.55 5.55 0 0 0 0 3.6l-2.12 1.56l.75 1.3l2.43-1.04c.77.88 1.82 1.52 3.01 1.76l.37 2.62h1.52l.37-2.61c1.19-.25 2.24-.89 3.01-1.77l2.43 1.04l.75-1.3l-2.12-1.55c.4-1.17.4-2.44 0-3.61l2.11-1.55l-.75-1.3l-2.41 1.04a5.42 5.42 0 0 0-3.03-1.77L12.75 4z"/></svg>
              </template>
            </fwb-sidebar-item>
          </template>
          <template #content>Logs Servidor</template>
        </fwb-tooltip>
        
        <!-- Salir -->
        <fwb-tooltip placement="right" theme="bg-darkgray">
          <template #trigger>
            <fwb-sidebar-item 
              class="m-2 p-2 text-base font-normal text-white transition-all duration-200 rounded-lg group hover:!bg-darkgray2 hover:scale-105"        
              :class="{ 'bg-darkgray': current_path == 'salir' }"
              @click="outsession"
            >
              <template #icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.67" d="M1.11 8.89h12.22m0 0L8.89 4.44m4.44 4.45-4.44 4.44m4.44-12.22h3.34c1.22 0 2.22 1 2.22 2.22v11.11c0 1.23-1 2.23-2.22 2.23h-3.34"/>
                </svg>
              </template>
            </fwb-sidebar-item>
          </template>
          <template #content>Salir</template>
        </fwb-tooltip>
      </div>

      <!-- Expanded Menu Items (sin cambios significativos, solo transiciones mejoradas) -->
      <div v-if="!isCollapsed">
        <!-- Dashboard -->
        <fwb-sidebar-item
          to="/dashboard"
          class="p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:bg-tuin-100 dark:text-black dark:hover:bg-gray-700"
          :class="{ 'bg-darkgray shadow-lg': current_path == 'dashboard' }"
          @click="change_path('dashboard')"
        >
          <template #icon>
            <svg class="text transition-transform duration-200 group-hover:rotate-12" width="20" height="20" viewBox="0 0 20 20" fill="#737373">
              <path d="M15.43 9.09H9.09V2.75c0-.54-.41-1-.95-.91C3.94 2.3 1 6.04 1 10.5 1 15.19 4.81 19 9.5 19c4.46 0 8.2-2.94 8.66-7.14.09-.54-.37-.95-.91-.95-.01 0-.01 0 0 0Z"/>
              <path d="M11.36 0c-.14 0-.28.01-.51.02-.45.08-.76.48-.76.93v8.14h8.16c.45 0 .85-.31.93-.76.01-.17.02-.34.02-.51C19.2 3.86 16.32.98 12.36.98-.64-.02 11.5 0 11.36 0Z"/>
            </svg>
          </template>
          <template #default>
            <span class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Dashboard</span>
          </template>
        </fwb-sidebar-item>

        <!-- Usuarios (Dropdown) -->
        <fwb-sidebar-dropdown-item 
          id="dorpdown_menu"
          ref="dropdownRef"
          class="group rounded-lg transition duration-75 rounded-lg group hover:text-black dark:hover:bg-gray-700"                 
        >
          <template #icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <g clip-path="url(#clip0_3710_3826)">
                <path d="M16.8341 15.4625C15.9466 14.0325 13.9928 12.5 9.99909 12.5C6.00534 12.5 4.05284 14.0312 3.16409 15.4625C3.98295 16.489 5.02274 17.3177 6.20611 17.8869C7.38948 18.4561 8.68596 18.7511 9.99909 18.75C11.3122 18.7511 12.6087 18.4561 13.7921 17.8869C14.9754 17.3177 16.0152 16.489 16.8341 15.4625Z" fill="#737373"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 11.25C10.9946 11.25 11.9484 10.8549 12.6517 10.1517C13.3549 9.44839 13.75 8.49456 13.75 7.5C13.75 6.50544 13.3549 5.55161 12.6517 4.84835C11.9484 4.14509 10.9946 3.75 10 3.75C9.00544 3.75 8.05161 4.14509 7.34835 4.84835C6.64509 5.55161 6.25 6.50544 6.25 7.5C6.25 8.49456 6.64509 9.44839 7.34835 10.1517C8.05161 10.8549 9.00544 11.25 10 11.25Z" fill="#737373"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 1.25C7.67936 1.25 5.45376 2.17187 3.81282 3.81282C2.17187 5.45376 1.25 7.67936 1.25 10C1.25 12.3206 2.17187 14.5462 3.81282 16.1872C5.45376 17.8281 7.67936 18.75 10 18.75C12.3206 18.75 14.5462 17.8281 16.1872 16.1872C17.8281 14.5462 18.75 12.3206 18.75 10C18.75 7.67936 17.8281 5.45376 16.1872 3.81282C14.5462 2.17187 12.3206 1.25 10 1.25ZM0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10Z" fill="#737373"/>
              </g>
            </svg>
          </template>
          <template #trigger>
            <span class="text-neutral-500 text-sm font-medium">
              Usuarios
            </span>
          </template>
          <template #default>
            <div class="relative pl-4 bg-transparent">
              <div class="absolute left-6 top-0 bottom-0 w-[1px] bg-neutral-700"></div>
              <fwb-sidebar-item
                to="/users"
                class="relative hover:bg-tuin-100 rounded-lg block pl-6 text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal py-2 before:absolute before:left-2 before:top-1/2 before:w-[14px] before:h-[1px] before:bg-neutral-700 before:-translate-y-1/2"
                :class="{ 'text-pink-500': current_path == 'users' }"
                @click="change_path('users')"            
              >
                <span 
                  v-if="current_path == 'users'" 
                  class="absolute left-1 top-1/2 transform -translate-y-1/2 w-1.5 h-1.5 bg-pink-500 rounded-full"
                ></span>
                Equipo Interno
              </fwb-sidebar-item>    
            </div>
          </template>
        </fwb-sidebar-dropdown-item>
      <!-- Asesores  -->
      <fwb-sidebar-item 
        to="/advisors"
        class="p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:bg-tuin-100 dark:text-black dark:hover:bg-gray-700"
        :class="{ 'bg-tuin-100': current_path == 'asesore' }"
        @click="change_path('asesor')"
      >
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
            <g clip-path="url(#clip0_3772_287)">
              <path d="M9.45587 0.479159C9.08871 0.169715 8.62399 0 8.14381 0C7.66364 0 7.19892 0.169715 6.83175 0.479159L0.723894 5.62967C0.497188 5.82073 0.314948 6.05901 0.189911 6.32784C0.0648754 6.59667 6.12856e-05 6.88956 0 7.18604V15.6104C0 16.4845 0.709417 17.1939 1.58352 17.1939H4.75056C5.17053 17.1939 5.57331 17.027 5.87028 16.7301C6.16724 16.4331 6.33408 16.0303 6.33408 15.6104V11.0797C6.33408 11.0197 6.35791 10.9622 6.40033 10.9197C6.44276 10.8773 6.5003 10.8535 6.56029 10.8535H9.72733C9.78733 10.8535 9.84487 10.8773 9.88729 10.9197C9.92972 10.9622 9.95355 11.0197 9.95355 11.0797V14.1499C10.3388 13.8288 10.8117 13.6311 11.3109 13.5826V12.9401C11.0148 12.4474 10.8584 11.8834 10.8584 11.3086C10.8584 10.9231 10.9272 10.5549 11.053 10.2137C10.909 9.99338 10.7125 9.81238 10.481 9.6871C10.2496 9.56181 9.99052 9.49619 9.72733 9.49617H6.56029C6.14032 9.49617 5.73754 9.663 5.44058 9.95997C5.14361 10.2569 4.97677 10.6597 4.97677 11.0797V15.6104C4.97677 15.6704 4.95294 15.7279 4.91052 15.7703C4.86809 15.8127 4.81055 15.8366 4.75056 15.8366H1.58352C1.52352 15.8366 1.46598 15.8127 1.42356 15.7703C1.38114 15.7279 1.3573 15.6704 1.3573 15.6104V7.18604C1.3574 7.08724 1.37908 6.98965 1.42081 6.9001C1.46254 6.81054 1.52332 6.73118 1.5989 6.66755L7.70676 1.51704C7.82911 1.41405 7.98389 1.35758 8.14381 1.35758C8.30374 1.35758 8.45852 1.41405 8.58086 1.51704L14.6887 6.66755C14.7643 6.73118 14.8251 6.81054 14.8668 6.9001C14.9086 6.98965 14.9302 7.08724 14.9303 7.18604V8.27188C15.4515 8.42752 15.9166 8.71346 16.2876 9.09169V7.18695C16.2876 6.89046 16.2228 6.59757 16.0977 6.32874C15.9727 6.05991 15.7904 5.82164 15.5637 5.63057L9.45587 0.479159ZM16.2876 11.3086C16.2876 11.9086 16.0493 12.484 15.6251 12.9082C15.2008 13.3325 14.6254 13.5708 14.0255 13.5708C13.4255 13.5708 12.8501 13.3325 12.4259 12.9082C12.0016 12.484 11.7633 11.9086 11.7633 11.3086C11.7633 10.7087 12.0016 10.1333 12.4259 9.70902C12.8501 9.28478 13.4255 9.04645 14.0255 9.04645C14.6254 9.04645 15.2008 9.28478 15.6251 9.70902C16.0493 10.1333 16.2876 10.7087 16.2876 11.3086ZM18.0974 16.1723C18.0974 17.5803 16.9337 19 14.0255 19C11.1172 19 9.95355 17.5857 9.95355 16.1723V16.0791C9.95355 15.1923 10.672 14.4757 11.5579 14.4757H16.493C17.3798 14.4757 18.0974 15.1932 18.0974 16.0791V16.1723Z" fill="#737373"/>
            </g>
            <defs>
              <clipPath id="clip0_3772_287">
                <rect width="19" height="19" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </template>
        <template #default>
          <span
            class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal"
          >
            Asesores
          </span>
        </template>
      </fwb-sidebar-item>
      <!-- Asesores -->
      
      <!-- Catalogos -->
      <fwb-sidebar-dropdown-item id="catalogue_dropdown" ref="dropdownRef" class="relative group">
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24" fill="none">
            <path fill="none" stroke="#737373" stroke-width="2" d="M5 6L1 4.5v13.943L12 23l11-4.557V4l-4 2M5 16V2l7 3l7-3v14l-7 3zm6.95-11v14"/>
          </svg>
        </template>
        <template #trigger>
          <span class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Catálogos</span>
        </template>
        <template #default>
          <div class="relative pl-4">
            <!-- Mueve la línea vertical más hacia adelante ajustando 'left' -->
            <div class="absolute left-6 top-0 bottom-0 w-[1px] bg-neutral-700"></div>

            <fwb-sidebar-item 
              v-for="(item, index) in [
                { path: 'rolesList', route: '/catalogs/roles', label: 'Roles' },
                { path: 'cargosList', route: '/catalogs/charges', label: 'Cargos' },
                { path: 'accountList', route: '/catalogs/accounts', label: 'Cuentas' },
                { path: 'planList', route: '/catalogs/plans', label: 'Planes' },
                { path: 'countriesList', route: '/catalogs/countries', label: 'Códigos telefónicos' }
              ]"
              :key="index"
              :to="item.route"
              class="relative hover:bg-tuin-100 rounded-lg block pl-6 text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal py-2 before:absolute before:left-2 before:top-1/2 before:w-[14px] before:h-[1px] before:bg-neutral-700 before:-translate-y-1/2"
              :class="{ 'text-pink-500': current_path == item.path }"
              @click="change_path(item.path)"
            >
              <span 
                v-if="current_path == item.path" 
                class="absolute left-1 top-1/2 transform -translate-y-1/2 w-1.5 h-1.5 bg-pink-500 rounded-full"
              ></span>
              {{ item.label }}
            </fwb-sidebar-item>
          </div>
        </template>
      </fwb-sidebar-dropdown-item>
      <!-- Catalogos -->

      <!-- Propiedades -->
      <fwb-sidebar-item
        to="/properties"
        class="p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:bg-tuin-100 dark:text-black dark:hover:bg-gray-700"
        :class="{ 'bg-tuin-100': current_path == 'properties' }"
        @click="change_path('properties')"
      >
        <template #icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="text-white text-xs"
            width="25"
            height="25"
            viewBox="0 0 2160 2160"
          >
            <path
              fill="#737373"
              d="M1280 1920h384v128h-512v-896H768v896H256V987l-83 82l-90-90l877-877l877 877l-90 90l-83-82v165h-128V859L960 282L384 859v1061h256v-896h640zm768-640v768h-128v-256h-512v-512zm-128 128h-384v256h384z"
            />
          </svg>
        </template>
        <template #default>
          <span class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal"> Propiedades </span>
        </template>
      </fwb-sidebar-item>
      <!-- Propiedades -->

      <!-- Prospectos -->
      <fwb-sidebar-item 
        to="/prospect/prospect-list"
        class="p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:bg-tuin-100 dark:text-black dark:hover:bg-gray-700"
        :class="{ 'bg-tuin-100': current_path == 'prospect' }"
        @click="change_path('prospect')"
      >
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.6875 18.375C19.6875 18.375 21 18.375 21 17.0625C21 15.75 19.6875 11.8125 14.4375 11.8125C9.1875 11.8125 7.875 15.75 7.875 17.0625C7.875 18.375 9.1875 18.375 9.1875 18.375H19.6875ZM9.21637 17.0625H19.6586C19.6648 
            17.0618 19.6709 17.0609 19.677 17.0599L19.6875 17.0573C19.6849 16.7108 19.4683 15.7054 18.69 14.7998C17.9655 13.9506 16.6924 13.125 14.4375 13.125C12.1839 13.125 10.9108 13.9519 10.185 14.7998C9.40669 15.7054 9.18881 16.7121 9.1875 17.0573C9.19711 17.0591 9.20673 
            17.0609 9.21637 17.0625ZM14.4375 9.1875C15.1337 9.1875 15.8014 8.91094 16.2937 8.41866C16.7859 7.92637 17.0625 7.25869 17.0625 6.5625C17.0625 5.86631 16.7859 5.19863 16.2937 4.70634C15.8014 4.21406 15.1337 3.9375 14.4375 3.9375C13.7413 3.9375 13.0736 4.21406 12.5813 
            4.70634C12.0891 5.19863 11.8125 5.86631 11.8125 6.5625C11.8125 7.25869 12.0891 7.92637 12.5813 8.41866C13.0736 8.91094 13.7413 9.1875 14.4375 9.1875ZM18.375 6.5625C18.375 7.07958 18.2732 7.5916 18.0753 8.06932C17.8774 8.54704 17.5874 8.9811 17.2217 9.34673C16.8561 9.71236 
            16.422 10.0024 15.9443 10.2003C15.4666 10.3982 14.9546 10.5 14.4375 10.5C13.9204 10.5 13.4084 10.3982 12.9307 10.2003C12.453 10.0024 12.0189 9.71236 11.6533 9.34673C11.2876 8.9811 10.9976 8.54704 10.7997 8.06932C10.6018 7.5916 10.5 7.07958 10.5 6.5625C10.5 5.51821 10.9148 4.51669 11.6533 3.77827C12.3917 
            3.03984 13.3932 2.625 14.4375 2.625C15.4818 2.625 16.4833 3.03984 17.2217 3.77827C17.9602 4.51669 18.375 5.51821 18.375 6.5625ZM9.1035 12.18C8.57848 12.0147 8.03727 11.906 7.48912 11.8558C7.18112 11.8265 6.87189 11.8121 6.5625 11.8125C1.3125 11.8125 0 15.75 0 17.0625C0 17.9379 0.437063 18.375 1.3125 
            18.375H6.846C6.65143 17.9653 6.55439 17.516 6.5625 17.0625C6.5625 15.7369 7.05731 14.3824 7.99312 13.251C8.31206 12.8651 8.6835 12.5042 9.1035 12.18ZM6.4575 13.125C4.26825 13.1512 3.02531 13.965 2.31 14.7998C1.52644 15.7106 1.3125 16.7199 1.3125 17.0625H5.25C5.25 15.6909 5.67394 14.3246 6.4575 13.125ZM1.96875 
            7.21875C1.96875 6.17446 2.38359 5.17294 3.12202 4.43452C3.86044 3.69609 4.86196 3.28125 5.90625 3.28125C6.95054 3.28125 7.95206 3.69609 8.69048 4.43452C9.42891 5.17294 9.84375 6.17446 9.84375 7.21875C9.84375 8.26304 9.42891 9.26456 8.69048 10.003C7.95206 10.7414 6.95054 11.1562 5.90625 11.1562C4.86196 11.1562 
            3.86044 10.7414 3.12202 10.003C2.38359 9.26456 1.96875 8.26304 1.96875 7.21875ZM5.90625 4.59375C5.21006 4.59375 4.54238 4.87031 4.05009 5.36259C3.55781 5.85488 3.28125 6.52256 3.28125 7.21875C3.28125 7.91494 3.55781 8.58262 4.05009 9.07491C4.54238 9.56719 5.21006 9.84375 5.90625 9.84375C6.60244 9.84375 7.27012 
            9.56719 7.76241 9.07491C8.25469 8.58262 8.53125 7.91494 8.53125 7.21875C8.53125 6.52256 8.25469 5.85488 7.76241 5.36259C7.27012 4.87031 6.60244 4.59375 5.90625 4.59375Z" fill="#737373"/>
          </svg>
        </template>
        <template #default>
          <span
            class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal"
          >
            Prospectos
          </span>
        </template>
      </fwb-sidebar-item>
      <!-- Prospectos -->

      <!-- Compañia -->
      <fwb-sidebar-item 
        to="/company/company-list"
        class="p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:bg-tuin-100 dark:text-black dark:hover:bg-gray-700"
        :class="{ 'bg-tuin-100': current_path == 'company' }"
        @click="change_path('company')"
      >
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 15.625C0 16.1223 0.197544 16.5992 0.549175 16.9508C0.900805 17.3025 1.37772 17.5 1.875 17.5H18.125C18.6223 17.5 19.0992 17.3025 19.4508 16.9508C19.8025 16.5992 20 16.1223 20 15.625V8.125H18.75V15.625C18.75 15.7908 18.6842 15.9497 18.5669 16.0669C18.4497 16.1842 18.2908 16.25 18.125 16.25H1.875C1.70924 16.25 1.55027 16.1842 1.43306 16.0669C1.31585 15.9497 1.25 15.7908 1.25 15.625V8.125H0V15.625Z" fill="#737373"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 5.625C0 5.12772 0.197544 4.65081 0.549175 4.29917C0.900805 3.94754 1.37772 3.75 1.875 3.75H18.125C18.6223 3.75 19.0992 3.94754 19.4508 4.29917C19.8025 4.65081 20 5.12772 20 5.625V8.605L10.4825 11.1425C10.1663 11.2267 9.83366 11.2267 9.5175 11.1425L0 8.605V5.625ZM1.875 5C1.70924 5 1.55027 5.06585 1.43306 5.18306C1.31585 5.30027 1.25 5.45924 1.25 5.625V7.645L9.83875 9.935C9.9444 9.96321 10.0556 9.96321 10.1612 9.935L18.75 7.645V5.625C18.75 5.45924 18.6842 5.30027 18.5669 5.18306C18.4497 5.06585 18.2908 5 18.125 5H1.875ZM6.25 3.125C6.25 2.62772 6.44754 2.15081 6.79917 1.79917C7.15081 1.44754 7.62772 1.25 8.125 1.25H11.875C12.3723 1.25 12.8492 1.44754 13.2008 1.79917C13.5525 2.15081 13.75 2.62772 13.75 3.125V3.75H12.5V3.125C12.5 2.95924 12.4342 2.80027 12.3169 2.68306C12.1997 2.56585 12.0408 2.5 11.875 2.5H8.125C7.95924 2.5 7.80027 2.56585 7.68306 2.68306C7.56585 2.80027 7.5 2.95924 7.5 3.125V3.75H6.25V3.125Z" fill="#737373"/>
          </svg>
        </template>
        <template #default>
          <span
            class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal"
          >
            Compañías
          </span>
        </template>
      </fwb-sidebar-item>
      <!-- Compañias -->

      <!-- Blog  -->
      <fwb-sidebar-dropdown-item 
        id="dorpdown_menu"
        ref="dropdownRef"
        class="text-base font-normal text-white transition duration-75 rounded-lg group hover:text-black dark:hover:bg-gray-700 "                 
      >
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.819 8.50031C14.7909 8.42236 14.733 8.35877 14.658 8.32352C14.583 8.28827 14.4971 8.28424 14.4191 8.31233L13.0497 8.80603L14.1608 11.8884L15.5301 11.3953C15.5687 11.3814 15.6043 11.36 15.6347 11.3323C15.6651 11.3047 15.6898 11.2713 15.7073 11.2341C15.7248 11.1969 15.7347 11.1566 15.7366 11.1156C15.7385 11.0745 15.7323 11.0335 15.7183 10.9948L14.819 8.50031ZM13.573 12.1003L12.4618 9.01795L7.05701 10.9664L7.17409 11.0214C7.2491 11.0566 7.30703 11.1203 7.33514 11.1982C7.36324 11.2762 7.35923 11.3621 7.32397 11.4371L7.19103 11.72L7.47385 11.8529C7.54885 11.8882 7.60678 11.9518 7.63489 12.0297C7.663 12.1077 7.65898 12.1936 7.62372 12.2686L7.49079 12.5515L7.7736 12.6844C7.84861 12.7197 7.90654 12.7833 7.93464 12.8612C7.96275 12.9392 7.95874 13.0251 7.92348 13.1001L7.79054 13.383L8.07335 13.5159C8.14836 13.5512 8.20629 13.6148 8.2344 13.6927C8.26251 13.7707 8.25849 13.8566 8.22323 13.9317L8.1682 14.0487L13.573 12.1003ZM7.3633 14.3389C7.36627 14.3017 7.3759 14.2652 7.39173 14.2314L7.52467 13.9486L7.24185 13.8157C7.16684 13.7804 7.10892 13.7168 7.08081 13.6388C7.0527 13.5608 7.05672 13.4749 7.09197 13.3999L7.22491 13.1171L6.9421 12.9842C6.86709 12.9489 6.80916 12.8853 6.78105 12.8073C6.75295 12.7293 6.75696 12.6434 6.79222 12.5684L6.92516 12.2856L6.64234 12.1526C6.56734 12.1174 6.50941 12.0538 6.4813 11.9758C6.45319 11.8978 6.45721 11.8119 6.49247 11.7369L6.6254 11.4541L6.34259 11.3211C6.3088 11.3052 6.27816 11.2833 6.25211 11.2565L6.10354 11.3096C6.06383 11.3241 6.02747 11.3465 5.99665 11.3754L3.53602 13.6718C3.49129 13.7135 3.45979 13.7674 3.44542 13.8269C3.43106 13.8864 3.43446 13.9487 3.4552 14.0063C3.47595 14.0638 3.51312 14.114 3.56213 14.1506C3.61113 14.1872 3.6698 14.2087 3.73086 14.2123L7.09075 14.4104C7.13294 14.413 7.17522 14.407 7.21503 14.3928L7.3633 14.3389Z" fill="#737373"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5 1.875H3.75C3.08696 1.875 2.45107 2.13839 1.98223 2.60723C1.51339 3.07607 1.25 3.71196 1.25 4.375V17.5C1.25 18.163 1.51339 18.7989 1.98223 19.2678C2.45107 19.7366 3.08696 20 3.75 20H16.25C16.913 20 17.5489 19.7366 18.0178 19.2678C18.4866 18.7989 18.75 18.163 18.75 17.5V4.375C18.75 3.71196 18.4866 3.07607 18.0178 2.60723C17.5489 2.13839 16.913 1.875 16.25 1.875H15V3.125H16.25C16.5815 3.125 16.8995 3.2567 17.1339 3.49112C17.3683 3.72554 17.5 4.04348 17.5 4.375V17.5C17.5 17.8315 17.3683 18.1495 17.1339 18.3839C16.8995 18.6183 16.5815 18.75 16.25 18.75H3.75C3.41848 18.75 3.10054 18.6183 2.86612 18.3839C2.6317 18.1495 2.5 17.8315 2.5 17.5V4.375C2.5 4.04348 2.6317 3.72554 2.86612 3.49112C3.10054 3.2567 3.41848 3.125 3.75 3.125H5V1.875Z" fill="#737373"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.875 1.25H8.125C7.95924 1.25 7.80027 1.31585 7.68306 1.43306C7.56585 1.55027 7.5 1.70924 7.5 1.875V3.125C7.5 3.29076 7.56585 3.44973 7.68306 3.56694C7.80027 3.68415 7.95924 3.75 8.125 3.75H11.875C12.0408 3.75 12.1997 3.68415 12.3169 3.56694C12.4342 3.44973 12.5 3.29076 12.5 3.125V1.875C12.5 1.70924 12.4342 1.55027 12.3169 1.43306C12.1997 1.31585 12.0408 1.25 11.875 1.25ZM8.125 0C7.62772 0 7.15081 0.197544 6.79917 0.549175C6.44754 0.900805 6.25 1.37772 6.25 1.875V3.125C6.25 3.62228 6.44754 4.09919 6.79917 4.45083C7.15081 4.80246 7.62772 5 8.125 5H11.875C12.3723 5 12.8492 4.80246 13.2008 4.45083C13.5525 4.09919 13.75 3.62228 13.75 3.125V1.875C13.75 1.37772 13.5525 0.900805 13.2008 0.549175C12.8492 0.197544 12.3723 0 11.875 0L8.125 0Z" fill="#737373"/>
          </svg>
        </template>
        <template #trigger>
          <span class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">
            Blog
          </span>
        </template>

        <template #default>
          <div class="relative pl-4">
            <!-- Línea vertical ajustada a la misma posición -->
            <div class="absolute left-6 top-0 bottom-0 w-[1px] bg-neutral-700"></div>

            <!-- Sidebar Item: Post -->
            <fwb-sidebar-item
              to="/blog/post"
              class="relative hover:bg-tuin-100 rounded-lg block pl-6 text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal py-2 before:absolute before:left-2 before:top-1/2 before:w-[14px] before:h-[1px] before:bg-neutral-700 before:-translate-y-1/2"
              :class="{ 
                'text-pink-500': current_path == 'post_list' 
              }"
              @click="change_path('post_list')"            
            >
              <!-- Círculo rosa indicador -->
              <span 
                v-if="current_path == 'post_list'" 
                class="absolute left-1 top-1/2 transform -translate-y-1/2 w-1.5 h-1.5 bg-pink-500 rounded-full"
              ></span>
              Post
            </fwb-sidebar-item>  

            <!-- Sidebar Item: Categorias -->
            <fwb-sidebar-item
              to="/blog/categories"
              class="relative hover:bg-tuin-100 rounded-lg block pl-6 text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal py-2 before:absolute before:left-2 before:top-1/2 before:w-[14px] before:h-[1px] before:bg-neutral-700 before:-translate-y-1/2"
              :class="{ 
                'text-pink-500': current_path == 'categorias_list' 
              }"
              @click="change_path('categorias_list')"            
            >
              <!-- Círculo rosa indicador -->
              <span 
                v-if="current_path == 'categorias_list'" 
                class="absolute left-1 top-1/2 transform -translate-y-1/2 w-1.5 h-1.5 bg-pink-500 rounded-full"
              ></span>
              Categorías
            </fwb-sidebar-item>  
          </div>
        </template>
      </fwb-sidebar-dropdown-item>
      <!-- Blog -->

      <!-- Legal -->
      <fwb-sidebar-item 
        to="/legal"
        class="p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:bg-tuin-100 dark:text-black dark:hover:bg-gray-700"
        :class="{ 'bg-tuin-100': current_path == 'legal' }"
        @click="change_path('legal')"
      >
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 15.625C0 16.1223 0.197544 16.5992 0.549175 16.9508C0.900805 17.3025 1.37772 17.5 1.875 17.5H18.125C18.6223 17.5 19.0992 17.3025 19.4508 16.9508C19.8025 16.5992 20 16.1223 20 15.625V8.125H18.75V15.625C18.75 15.7908 18.6842 15.9497 18.5669 16.0669C18.4497 16.1842 18.2908 16.25 18.125 16.25H1.875C1.70924 16.25 1.55027 16.1842 1.43306 16.0669C1.31585 15.9497 1.25 15.7908 1.25 15.625V8.125H0V15.625Z" fill="#737373"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 5.625C0 5.12772 0.197544 4.65081 0.549175 4.29917C0.900805 3.94754 1.37772 3.75 1.875 3.75H18.125C18.6223 3.75 19.0992 3.94754 19.4508 4.29917C19.8025 4.65081 20 5.12772 20 5.625V8.605L10.4825 11.1425C10.1663 11.2267 9.83366 11.2267 9.5175 11.1425L0 8.605V5.625ZM1.875 5C1.70924 5 1.55027 5.06585 1.43306 5.18306C1.31585 5.30027 1.25 5.45924 1.25 5.625V7.645L9.83875 9.935C9.9444 9.96321 10.0556 9.96321 10.1612 9.935L18.75 7.645V5.625C18.75 5.45924 18.6842 5.30027 18.5669 5.18306C18.4497 5.06585 18.2908 5 18.125 5H1.875ZM6.25 3.125C6.25 2.62772 6.44754 2.15081 6.79917 1.79917C7.15081 1.44754 7.62772 1.25 8.125 1.25H11.875C12.3723 1.25 12.8492 1.44754 13.2008 1.79917C13.5525 2.15081 13.75 2.62772 13.75 3.125V3.75H12.5V3.125C12.5 2.95924 12.4342 2.80027 12.3169 2.68306C12.1997 2.56585 12.0408 2.5 11.875 2.5H8.125C7.95924 2.5 7.80027 2.56585 7.68306 2.68306C7.56585 2.80027 7.5 2.95924 7.5 3.125V3.75H6.25V3.125Z" fill="#737373"/>
          </svg>
        </template>
        <template #default>
          <span
            class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal"
          >
            Legal
          </span>
        </template>
      </fwb-sidebar-item>
      <!-- Legal -->

      <!-- Reportes -->
      <fwb-sidebar-dropdown-item 
        id="reports_dropdown"
        ref="reportsDropdownRef"
        class="text-base font-normal text-white transition duration-75 rounded-lg group hover:text-black dark:hover:bg-gray-700"                 
      >
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M9 17V15H13V17H9ZM9 13V11H17V13H9ZM9 9V7H17V9H9ZM5 21C4.45 21 3.979 20.804 3.587 20.412C3.195 20.02 2.99934 19.5493 3 19V5C3 4.45 3.196 3.979 3.588 3.587C3.98 3.195 4.45067 2.99934 5 3H19C19.55 3 20.021 3.196 20.413 3.588C20.805 3.98 21.0007 4.45067 21 5V19C21 19.55 20.804 20.021 20.412 20.413C20.02 20.805 19.5493 21.0007 19 21H5ZM5 19H19V5H5V19Z" fill="#737373"/>
          </svg>
        </template>
        <template #trigger>
          <span class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">
            Reportes
          </span>
        </template>

        <template #default>
          <div class="relative pl-4">
            <!-- Línea vertical ajustada a la misma posición -->
            <div class="absolute left-6 top-0 bottom-0 w-[1px] bg-neutral-700"></div>

            <!-- Lista de Reportes -->
            <fwb-sidebar-item
              to="/reports/list"
              class="relative hover:bg-tuin-100 rounded-lg block pl-6 text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal py-2 before:absolute before:left-2 before:top-1/2 before:w-[14px] before:h-[1px] before:bg-neutral-700 before:-translate-y-1/2"
              :class="{'text-pink-500': current_path == 'reports_list'}"
              @click="change_path('reports_list')"            
            >
              <!-- Círculo rosa indicador alineado al vértice de la línea -->
              <span 
                v-if="current_path == 'reports_list'" 
                class="absolute left-1 top-1/2 transform -translate-y-1/2 w-1.5 h-1.5 bg-pink-500 rounded-full"
              ></span>
              Lista 
            </fwb-sidebar-item>

            <!-- Razones de Reportes -->
            <fwb-sidebar-item
              to="/reports/reasons"
              class="relative hover:bg-tuin-100 rounded-lg block pl-6 text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal py-2 before:absolute before:left-2 before:top-1/2 before:w-[14px] before:h-[1px] before:bg-neutral-700 before:-translate-y-1/2"
              :class="{'text-pink-500': current_path == 'reports_reasons_list'}"
              @click="change_path('reports_reasons_list')"            
            >
              <!-- Círculo rosa indicador -->
              <span 
                v-if="current_path == 'reports_reasons_list'" 
                class="absolute left-1 top-1/2 transform -translate-y-1/2 w-1.5 h-1.5 bg-pink-500 rounded-full"
              ></span>
              Motivos
            </fwb-sidebar-item>  
          </div>
        </template>
      </fwb-sidebar-dropdown-item>
      <!-- Reportes -->

      <!-- Logs Servidor -->
      <fwb-sidebar-item 
        @click="redirectToTelescope"
        class="p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:bg-tuin-100 dark:text-black dark:hover:bg-gray-700"
      >
      <template #icon>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#555050" d="M12 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-2 12c-.25 0-.46-.18-.5-.42l-.37-2.65c-.63-.25-1.17-.59-1.69-.99l-2.49 1.01c-.22.08-.49 0-.61-.22l-2-3.46a.493.493 0 0 1 .12-.64l2.11-1.66L4.5 12l.07-1l-2.11-1.63a.493.493 0 0 1-.12-.64l2-3.46c.12-.22.39-.31.61-.22l2.49 1c.52-.39 1.06-.73 1.69-.98l.37-2.65c.04-.24.25-.42.5-.42h4c.25 0 .46.18.5.42l.37 2.65c.63.25 1.17.59 1.69.98l2.49-1c.22-.09.49 0 .61.22l2 3.46c.13.22.07.49-.12.64L19.43 11l.07 1l-.07 1l2.11 1.63c.19.15.25.42.12.64l-2 3.46c-.12.22-.39.31-.61.22l-2.49-1c-.52.39-1.06.73-1.69.98l-.37 2.65c-.04.24-.25.42-.5.42zm1.25-18l-.37 2.61c-1.2.25-2.26.89-3.03 1.78L5.44 7.35l-.75 1.3L6.8 10.2a5.55 5.55 0 0 0 0 3.6l-2.12 1.56l.75 1.3l2.43-1.04c.77.88 1.82 1.52 3.01 1.76l.37 2.62h1.52l.37-2.61c1.19-.25 2.24-.89 3.01-1.77l2.43 1.04l.75-1.3l-2.12-1.55c.4-1.17.4-2.44 0-3.61l2.11-1.55l-.75-1.3l-2.41 1.04a5.42 5.42 0 0 0-3.03-1.77L12.75 4z"/></svg>
        </template>
        <template #default>
          <span class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">
            Logs servidor
          </span>
        </template>
      </fwb-sidebar-item>
      <!-- Logs Servidor -->

      <!-- Configuración 
      <fwb-sidebar-dropdown-item 
        id="dorpdown_menu"
        ref="dropdownRef"
        class="text-base font-normal text-white transition duration-75 rounded-lg group hover:text-black dark:hover:bg-gray-700 "                 
      >
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#555050" d="M12 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-2 12c-.25 0-.46-.18-.5-.42l-.37-2.65c-.63-.25-1.17-.59-1.69-.99l-2.49 1.01c-.22.08-.49 0-.61-.22l-2-3.46a.493.493 0 0 1 .12-.64l2.11-1.66L4.5 12l.07-1l-2.11-1.63a.493.493 0 0 1-.12-.64l2-3.46c.12-.22.39-.31.61-.22l2.49 1c.52-.39 1.06-.73 1.69-.98l.37-2.65c.04-.24.25-.42.5-.42h4c.25 0 .46.18.5.42l.37 2.65c.63.25 1.17.59 1.69.98l2.49-1c.22-.09.49 0 .61.22l2 3.46c.13.22.07.49-.12.64L19.43 11l.07 1l-.07 1l2.11 1.63c.19.15.25.42.12.64l-2 3.46c-.12.22-.39.31-.61.22l-2.49-1c-.52.39-1.06.73-1.69.98l-.37 2.65c-.04.24-.25.42-.5.42zm1.25-18l-.37 2.61c-1.2.25-2.26.89-3.03 1.78L5.44 7.35l-.75 1.3L6.8 10.2a5.55 5.55 0 0 0 0 3.6l-2.12 1.56l.75 1.3l2.43-1.04c.77.88 1.82 1.52 3.01 1.76l.37 2.62h1.52l.37-2.61c1.19-.25 2.24-.89 3.01-1.77l2.43 1.04l.75-1.3l-2.12-1.55c.4-1.17.4-2.44 0-3.61l2.11-1.55l-.75-1.3l-2.41 1.04a5.42 5.42 0 0 0-3.03-1.77L12.75 4z"/></svg>
        </template>
        <template #trigger>
          <span 
            class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal"
          >Configuración</span>
        </template>

        <template #default>
          <fwb-sidebar-item
            to="/info-profile"
            class="p-2 pl-4 text-base font-normal text-white transition duration-75 rounded-lg group hover:bg-tuin-100 dark:text-black dark:hover:bg-gray-700"
            :class="{ 'bg-tuin-100': current_path == 'info-profile' }"
            @click="change_path('info-profile')"            
          >
            Perfil
          </fwb-sidebar-item>
          <fwb-sidebar-item
            to="/info-company"
            class="p-2 pl-4 text-base font-normal text-white transition duration-75 rounded-lg group hover:bg-tuin-100 dark:text-black dark:hover:bg-gray-700"
            :class="{ 'bg-tuin-100': current_path == 'info-company' }"
            @click="change_path('info-company')"
          >
            Compañía 
          </fwb-sidebar-item>
          <fwb-sidebar-item
            to="/info-password"
            class="p-2 pl-4 text-base font-normal text-white transition duration-75 rounded-lg group hover:bg-tuin-100 dark:text-black dark:hover:bg-gray-700"
            :class="{ 'bg-tuin-100': current_path == 'info-password' }"
            @click="change_path('info-password')"
          >
            Contraseña
          </fwb-sidebar-item>
          <fwb-sidebar-item
            to="/info-networks"
            class="p-2 pl-4 text-base font-normal text-white transition duration-75 rounded-lg group hover:bg-tuin-100 dark:text-black dark:hover:bg-gray-700"
            :class="{ 'bg-tuin-100': current_path == 'info-networks' }"
            @click="change_path('info-networks')"
          >
            Redes sociales
          </fwb-sidebar-item>          
        </template>
      </fwb-sidebar-dropdown-item>
      Configuración  -->

       <!-- Salir  -->
        <fwb-sidebar-item 
          class="p-2 text-base font-normal text-white transition duration-75 rounded-lg group hover:bg-tuin-100 dark:text-black dark:hover:bg-gray-700 "
          @click="outsession"
        >
          <template #icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.67" d="M1.11 8.89h12.22m0 0L8.89 4.44m4.44 4.45-4.44 4.44m4.44-12.22h3.34c1.22 0 2.22 1 2.22 2.22v11.11c0 1.23-1 2.23-2.22 2.23h-3.34" />
            </svg>
          </template>
          <template #default>
            <span class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Salir</span>
          </template>
        </fwb-sidebar-item>
      </div>
    </div>
  </fwb-sidebar>
</template>

<script setup>
import {
  FwbSidebar,
  FwbSidebarItem,
  FwbSidebarDropdownItem,
  FwbTooltip
} from "flowbite-vue";
import { ref, onMounted, reactive } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const store = useStore();
const router = useRouter();

// Props
defineProps({
  isCollapsed: {
    type: Boolean,
    required: false,
    default: false
  }
});

// Emits
defineEmits(['toggle-collapse']);

// Reactive data
const current_path = ref("dashboard");
const floatingMenus = reactive({
  usuarios: false,
  catalogos: false,
  blog: false,
  reportes: false,
  configuracion: false
});

const backendUrl = process.env.VUE_APP_API_BASE_URL.replace('/api', '');
const telescopeUrl = `${backendUrl}/telescope`;

const showFloatingMenu = (menu) => {
  floatingMenus[menu] = true;
};

const hideFloatingMenu = (menu) => {
  setTimeout(() => {
    floatingMenus[menu] = false;
  }, 300);
};

const navigateTo = (route, path) => {
  current_path.value = path;
  router.push(route);
  Object.keys(floatingMenus).forEach(key => {
    floatingMenus[key] = false;
  });
};

const redirectToTelescope = () => {
  window.open(telescopeUrl, '_blank');
};

async function outsession() {
  await store.dispatch("clearUserSession");
  window.location.replace("/login");
}

function change_path(path_link) {
  current_path.value = path_link;
}

const setActivePath = () => {
  const path = window.location.pathname;
  switch (path) {
    case '/dashboard':
      current_path.value = 'dashboard';
      break;
    case '/properties':
      current_path.value = 'properties';
      break;
    case '/prospect':
      current_path.value = 'prospect';
      break;
    case '/info-profile':
      current_path.value = 'info-profile';
      break;
    case '/info-company':
      current_path.value = 'info-company';
      break;
    case '/info-password':
      current_path.value = 'info-password';
      break;
    case '/info-networks':
      current_path.value = 'info-networks';
      break;
    default:
      current_path.value = '';
      break;
  }
};

onMounted(() => {
  setActivePath();
});
</script>

<style scoped>
aside > div:first-child {
  background-color: black !important;
  color: white;
}

/* Animación para menús flotantes */
.slide-fade-enter-active {
  transition: all 0.2s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.15s ease-in;
}

.slide-fade-enter-from {
  transform: translateX(-10px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}

:deep(.fwb-sidebar-dropdown-item) {
  background-color: transparent !important;
}

:deep(.fwb-sidebar-dropdown-item > button) {
  background-color: transparent !important;
  padding: 0.5rem;
  transition: background-color 75ms;
}

:deep(.fwb-sidebar-dropdown-item > button:hover) {
  background-color: #1a1a1a !important;
}

:deep(.fwb-sidebar-dropdown-item > ul) {
  background-color: transparent !important;
  padding-left: 0 !important;
}

/* Scroll personalizado */
::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 2px;
}

::-webkit-scrollbar-thumb:hover {
  background: #4B5563;
}
</style>